import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("question_type_master")
export class QuestionTypeMaster {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "type", length: 255, nullable: true })
  type: string | null;

  @Column("tinyint", { name: "status", default: () => '1' })
  status: number;
}
